import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M40 16H56V40H40V56H16V40H0V16H16V0H40V16Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 56

/**
 * Plus shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const PlusShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default PlusShape
